// Column ids — used by the column defs and by the row view model.
export const TRANSACTION_COLUMNS = Object.freeze({
  serialNo: 'serialNo',
  declarationNo: 'declarationNo',
  associatedId: 'associatedId',
  materialName: 'materialName',
  associatedSite: 'associatedSite',
  terminal: 'terminal',
  type: 'type',
  unitType: 'unitType',
  quantity: 'quantity',
  balance: 'balance',
  sendTo: 'sendTo',
  transactionDate: 'transactionDate',
  ghgEmission: 'ghgEmission',
  ghgEmissionSavings: 'ghgEmissionSavings',
  countryOfOrigin: 'countryOfOrigin',
  rawMaterialType: 'rawMaterialType',
  feedstockCategory: 'feedstockCategory',
  allocationPreference: 'allocationPreference',
  massBalancePeriod: 'massBalancePeriod',
  transactedBy: 'transactedBy',
});

// Filter panel field ids — each a `TransactionFilters` key.
export const TRANSACTION_FILTERS = Object.freeze({
  materialId: 'materialId',
  counterpartyAccountId: 'counterpartyAccountId',
});
